import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=c642d2ac&scoped=true"
import script from "./Organisations.vue?vue&type=script&lang=ts"
export * from "./Organisations.vue?vue&type=script&lang=ts"
import style0 from "./Organisations.vue?vue&type=style&index=0&id=c642d2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642d2ac",
  null
  
)

export default component.exports